<template>
    <div>
        <v-card :loading="loading" outlined>
            <v-toolbar dense flat color="blue-grey lighten-5" height="30">
                <v-toolbar-title class="subtitle-1">Enviar copia a:</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="!soloLectura" 
                    x-small icon fab 
                    @click="asignarDialog=true">
                    <v-icon>fa-user-plus</v-icon>
                </v-btn>
            </v-toolbar>
                <v-container>
                    <v-row no-gutters>
                        <div v-if="ccp.length == 0"><i>No se han registrado usuarios</i></div>
                        <v-col cols="6" v-for="(item,index) in ccp" :key="index" style="padding:4px">
                            <v-list-item>
                                <v-list-item-action>
                                    <menu-item
                                        :items="menuItems()"
                                        :id="item._id"
                                        @menuAction="menuAction"
                                    />
                                    <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-if="!item.enviado" color="orange" v-on="on">mdi-email-alert</v-icon>
                                            <v-icon v-else color="green" v-on="on">mdi-email-check</v-icon>
                                        </template>
                                        <span v-if="!item.enviado">Correo no enviado</span>
                                        <span v-else>Correo enviado</span>
                                    </v-tooltip>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{item.responsable}}</v-list-item-title>
                                    <v-list-item-subtitle>{{item.cargo}}</v-list-item-subtitle>
                                    <v-list-item-subtitle>{{item.dependencia}}</v-list-item-subtitle>
                                    <v-list-item-subtitle v-if="item.correoPara">{{item.correoPara}}</v-list-item-subtitle>
                                    <v-list-item-subtitle v-else><i>No hay correo registrado</i></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                </v-container>
        </v-card>

        <v-dialog v-model="asignarDialog" persistent max-width="700">
            <v-card :loading="loading">
                <v-card-title class="headline">Enviar copia a:</v-card-title>
                <v-card-text>
                    <v-tabs fixed-tabs background-color="blue-grey" dark dense v-model="tab">
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                        <v-tab href="#tab-entidades">Entidades</v-tab>
                        <v-tab href="#tab-manual">Manual</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item value="tab-entidades">
                            <v-card flat>
                                <buscarEmisorEntidadComponent
                                  :tipo="'CPP'"
                                  :entidades="entidades"
                                  @seleccionarEntidad="seleccionarEntidad"
                                />

                                <v-autocomplete 
                                    v-model="entidadSel"
                                    :items="entidades"
                                    item-text="nombre"
                                    item-value="_id"
                                    label="Entidad:"
                                    return-object
                                />
                                <v-text-field 
                                    v-model="entidadSel.responsable"
                                    label="Responsable:"
                                    :disabled="true"
                                />
                                <v-text-field 
                                    v-model="entidadSel.cargo"
                                    label="Cargo:"
                                    :disabled="true"
                                />
                                <v-text-field 
                                    v-model="entidadSel.correo"
                                    label="Correo:"
                                    :disabled="true"
                                />

                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-manual">
                            <v-card flat>
                                <v-text-field 
                                    v-model="manual.dependencia"
                                    label="Dependencia:"
                                    :error-messages="dependenciaErrors"
                                    @input="$v.manual.dependencia.$touch()"
                                    @blur="$v.manual.dependencia.$touch()"
                                />
                                <v-text-field 
                                    v-model="manual.nombre"
                                    label="Responsable:"
                                    :error-messages="nombreErrors"
                                    @input="$v.manual.nombre.$touch()"
                                    @blur="$v.manual.nombre.$touch()"
                                />
                                <v-text-field 
                                    v-model="manual.cargo"
                                    label="Cargo:"
                                    :error-messages="cargoErrors"
                                    @input="$v.manual.cargo.$touch()"
                                    @blur="$v.manual.cargo.$touch()"
                                />
                                <v-text-field 
                                    v-model="manual.correo"
                                    label="Correo:"
                                    :error-messages="correoErrors"
                                    @input="$v.manual.correo.$touch()"
                                    @blur="$v.manual.correo.$touch()"
                                />

                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
                <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue-grey darken-1" small outlined text @click="asignarDialog=false">Cancelar</v-btn>
                <v-btn color="blue-grey darken-1" small dark  @click="asignarCcp()">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <mensaje-confirmar
            :mostrar="removerCcp.mostrar"
            :titulo="removerCcp.titulo"
            :texto="removerCcp.texto"
            @cancelar="removerCcp.mostrar=false"
            @aceptar="removerUsuario()"
        />

        <v-dialog v-model="enviandoCorreo" persistent width="300">
            <v-card color="blue-grey" dark>
                <v-card-text>
                    Enviando correo...
                    <v-progress-linear
                        color="white"
                        class="mb-0"
                        indeterminate
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>


      <v-dialog v-model="mensajeEnviarCorreo.mostrar" persistent max-width="600" hide-overlay transition="scale-transition">
        <v-card>
          <v-toolbar dense color="blue-grey darken-1" dark flat class="text-h6">{{`Enviar copia a ${mensajeEnviarCorreo.correo}`}}</v-toolbar>
          <v-container grid-list-md>
            <v-alert color="orange lighten-1" dense dark style="text-align: center">El oficio será enviado con el correo atencion.secretaria@administrativos.udg.mx.</v-alert>
            <p><b>Otras configuraciones:</b></p>
            <v-checkbox
              v-model="correoPersonal"
              dense
              :disabled="!this.userCorreo"
              :label="this.userCorreo ? `Enviar cco a ${this.userCorreo}` : 'No cuenta con correo'"
            ></v-checkbox>
          </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue-grey darken-1" 
                small 
                outlined 
                :disabled="loading" 
                @click="mensajeEnviarCorreo.mostrar = false">Cancelar</v-btn>
                <v-btn color="blue-grey darken-1" 
                small
                dark
                :loading="loading" 
                @click="enviarCorreo()">Enviar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
        
    </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import MenuItem from '../menus/MenuItem';
import MensajeConfirmar from '../MainTemplate/mensajeConfirmar';
import buscarEmisorEntidadComponent from "../widgets/buscarEmisorEntidad.vue";

export default {
    name: 'cppOficio',
    props: ['idOficio','ccp','soloLectura','tipo'],
    mixins: [validationMixin],
    components:{ MenuItem, MensajeConfirmar, buscarEmisorEntidadComponent },
    computed:{
        ...mapGetters([
            "httpURL", 
            "sessionToken",
            "userId",
            "userCorreo"
        ]),
        dependenciaErrors() {
            const errors = [];
            if (!this.$v.manual.dependencia.$dirty) return errors;
            !this.$v.manual.dependencia.required && errors.push("Campo requerido.");
            return errors;
        },
        nombreErrors() {
            const errors = [];
            if (!this.$v.manual.nombre.$dirty) return errors;
            !this.$v.manual.nombre.required && errors.push("Campo requerido.");
            return errors;
        },
        cargoErrors() {
            const errors = [];
            if (!this.$v.manual.cargo.$dirty) return errors;
            !this.$v.manual.cargo.required && errors.push("Campo requerido.");
            return errors;
        },
        correoErrors() {
            const errors = [];
            if (!this.$v.manual.correo.$dirty) return errors;
            !this.$v.manual.correo.required && errors.push("Campo requerido.");
            !this.$v.manual.correo.email && errors.push("Correo no válido.");
            return errors;
        },
    },
    watch:{
        'asignarDialog'(nuevo, anterior){
            if( nuevo ){
                this.entidades = this.entidades.filter(x=>{
                    let found = false;
                    for(let i=0; i<this.ccp.length; i++){
                        if( this.ccp[i].dependencia == x.nombre ){
                            found = true;
                            break;
                        }
                    };
                    return !found;
                });
                this.entidadSel = this.entidades[0];
            }
        },
    },
    data: () => ({
        loading: false,
        enviandoCorreo: false,
        tab: null,
        entidades: [],
        entidadSel: {},
        manual:{
            dependencia: null,
            nombre: null,
            cargo: null,
            correo: null
        },
        asignarDialog: false,
        removerCcp: {
            mostrar: false,
            id: null,
            titulo: "Remover usuario",
            texto: '¿Está seguro de quitar el registro?'
        },
        mensajeEnviarCorreo: {
          mostrar: false,
          id: null,
          correo: null,
        },
        correoPersonal: false
    }),
    validations:{
        manual: {
            dependencia: {required},
            nombre: {required},
            cargo: {required},
            correo: {required, email}
        }
    },
    mounted(){
        this.loading = true;
        axios.get(this.httpURL+'/oficios/entidades',
            {headers:{token:this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                if( res.data.ok ){
                    this.entidades = res.data.entidades;
                    this.entidadSel = this.entidades[0];
                }else{
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                }
                this.loading = false;
            })
            .catch(error => {
                // console.log('Error: '+error);
                this.loading = false;
                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
            });
    },
    methods:{
        menuItems(){
            let menu = [];
            menu.push({text:'Enviar correo', action: 'enviarCorreo'});
            menu.push({text:'Remover usuario', action: 'removerUsuario'});
            return menu;
        },
        menuAction(action, id){
            switch(action){
                case 'enviarCorreo':
                    this.mensajeEnviarCorreo.mostrar = true;
                    this.mensajeEnviarCorreo.id = id;
                    let ccp = this.ccp.find(x=>x._id == this.mensajeEnviarCorreo.id);
                    this.mensajeEnviarCorreo.correo = ccp.correoPara;
                    break;
                case 'removerUsuario':
                    this.removerCcp.id = id;
                    this.removerCcp.mostrar = true;
                    break;
            }
        },
        asignarCcp(){
            let data = {};
            let validado = false;
            if( this.tab == 'tab-entidades'){
                data.dependencia = this.entidadSel.nombre;
                data.responsable = this.entidadSel.responsable;
                data.cargo = this.entidadSel.cargo;
                data.correo = this.entidadSel.correo;
                validado = true;
            }
            if( this.tab == 'tab-manual'){
                data.dependencia = this.manual.nombre;
                data.responsable = this.manual.nombre;
                data.cargo = this.manual.cargo;
                data.correo = this.manual.correo;
                this.$v.$touch();
                if (!this.$v.$invalid)
                validado = true;
            }

            if( validado ){
                this.loading = true;
                axios.post(this.httpURL+'/oficios/'+this.tipo+'/ccp/'+this.idOficio,
                    {data},
                    {headers:{token:this.sessionToken}})
                    .then(res => {
                        // console.log(res.data);
                        if( res.data.ok ){
                            // console.log(res.data);
                            this.$emit('ccpAgregado',res.data.ccp);
                            this.asignarDialog = false;
                        }else{
                            this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                        }
                        this.loading = false;
                    })
                    .catch(error => {
                        // console.log(error);
                        this.loading = false;
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                    });
            }

        },
        removerUsuario(){
            // console.log('Remover '+id);
            this.loading = true;
            axios.delete(this.httpURL+'/oficios/'+this.tipo+'/ccp/'+this.idOficio,
                {
                    headers:{token:this.sessionToken},
                    data: { idCcp: this.removerCcp.id}
                })
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        // console.log(res.data);
                        this.$emit('ccpRemovido',this.removerCcp.id);
                        this.removerCcp.mostrar = false;
                    }else{
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
        },
        enviarCorreo(){
            let ccp = this.ccp.find(x=>x._id == this.mensajeEnviarCorreo.id);
            let correoCopia = null;
            if(this.correoPersonal) correoCopia = this.userCorreo;

            const sendData = { 
              idCcp: this.mensajeEnviarCorreo.id, 
              correoCopia 
            };
            if( !ccp.correoPara )
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'No hay correo registrado.' });
            else{
                this.enviandoCorreo = true;
                axios.put(this.httpURL+'/oficios/'+this.tipo+'/correo/'+this.idOficio,
                    {sendData},
                    {headers:{token:this.sessionToken}})
                    .then(res => {
                        if( res.data.ok ){
                            let index = this.ccp.findIndex(x=>x._id == this.mensajeEnviarCorreo.id);
                            this.ccp[index].enviado = true;
                            this.asignarDialog = false;
                            this.correoPersonal = false;
                            this.mensajeEnviarCorreo.mostrar = false;
                            this.mensajeEnviarCorreo.id = null;
                            this.mensajeEnviarCorreo.correo = null;
                        }else{
                            this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                        }
                        this.enviandoCorreo = false;
                    })
                    .catch(error => {
                        // console.log(error);
                        this.enviandoCorreo = false;
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                    });
            }
        },
        seleccionarEntidad(entidad) {
          this.entidadSel = entidad;
        }
    }
}
</script>